import React from "react";
import styles from "../../../views/DetailMDR/DetailMDR.module.css";
import NotReportViewData from "../../NotReportViewData/NotReportView";
import { VscPreview } from "react-icons/vsc";

const HeaderMDR = ({ data }) => {
  const changeColoResult = () => {
    if (data.Risk.data === "Riesgo bajo") {
      return <p className={styles.Lealtadmdrlow}>{data.Risk.data}</p>;
    } else if (data.Risk.data === "Riesgo medio") {
      return <p className={styles.Lealtadmdrmid}>{data.Risk.data}</p>;
    } else {
      return <p className={styles.Lealtadmdrheig}>{data.Risk.data}</p>;
    }
  };
  return (
    <div className={styles.Lealtadheader}>
      {!data ? (
        <NotReportViewData title="Informe de Matriz" Icon={VscPreview} />
      ) : (
        <>
          <div className={styles.LealtadlineBotton}>
            <h2 className={styles.Lealtadtitle}>
              <p className={styles.Lealtadptittle}>{data.cuil + " / "}</p>
              <p className={styles.Lealtadptittle}>{data.lastName}</p>
              <p className={styles.Lealtadptittle}> - {data.name}</p>
              {changeColoResult()}
            </h2>
          </div>
          <div className={styles.Lealtadinfo}>
            <div className={styles.LealtadinfoTitle}>
              <p>Datos de la busqueda</p>
            </div>
            <div className={styles.LealtadinfoSubTitle}>
              <p>Datos ingresados: </p>
            </div>
            <div className={styles.LealtadinfoRows}>
              <div className={styles.LealtadinfoRow}>
                <p className={styles.Lealtaddatainfo}>
                  Calle:
                  <span
                    style={{
                      color: "#7acdf1",
                      fontsize: "1em",
                      margin: "0px 10px",
                      fontfamily: "sans-serif",
                      fontweight: "600 ",
                    }}
                  >
                    {data.street}
                  </span>
                </p>
                <p className={styles.Lealtaddatainfo}>
                  Número:
                  <span
                    style={{
                      color: "#7acdf1",
                      fontsize: "1em",
                      margin: "0px 10px",
                      fontfamily: "sans-serif",
                      fontweight: "600 ",
                    }}
                  >
                    {data.numberStreet}
                  </span>
                </p>
              </div>
              <div className={styles.LealtadinfoRow}>
                <p className={styles.Lealtaddatainfo}>
                  Piso/Departamento:
                  <span
                    style={{
                      color: "#7acdf1",
                      fontsize: "1em",
                      margin: "0px 10px",
                      fontfamily: "sans-serif",
                      fontweight: "600 ",
                    }}
                  >
                    {data.apart} {data.floor}
                  </span>
                </p>
                <p className={styles.Lealtaddatainfo}>
                  CP:
                  <span
                    style={{
                      color: "#7acdf1",
                      fontsize: "1em",
                      margin: "0px 10px",
                      fontfamily: "sans-serif",
                      fontweight: "600 ",
                    }}
                  >
                    {data.postalCode}
                  </span>
                </p>
              </div>
              <div className={styles.LealtadinfoRow}>
                <p className={styles.Lealtaddatainfo}>
                  Localidad:
                  <span
                    style={{
                      color: "#7acdf1",
                      fontsize: "1em",
                      margin: "0px 10px",
                      fontfamily: "sans-serif",
                      fontweight: "600 ",
                    }}
                  >
                    {data.location}
                  </span>
                </p>
                <p className={styles.Lealtaddatainfo}>
                  Provincia:
                  <span
                    style={{
                      color: "#7acdf1",
                      fontsize: "1em",
                      margin: "0px 10px",
                      fontfamily: "sans-serif",
                      fontweight: "600 ",
                    }}
                  >
                    {data.province}
                  </span>
                </p>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default HeaderMDR;
